import {
  DynamicFormInputType,
  FormInputTypes,
} from '@components/_old/dynamicForm';

export const getModelInputs = (
  brandLovs: any,
  model: any = {},
  isEdit = false
): Record<string, DynamicFormInputType> => {
  const brandValue =
    model?.brand || model?.Insurance_Brands || model?.Brand?.Code || '';

  const prefixValue =
    brandValue && brandValue !== '' ? `${brandValue}Model` : '';

  return {
    brand: {
      name: 'brand',
      title: 'Brand',
      type: FormInputTypes.chips,
      value: brandValue,
      required: true,
      selectOptions: brandLovs as any,
      placeholder: 'Choose Brand',
      disabled: isEdit,
    },
    code: {
      name: 'code',
      title: 'Base Code',
      placeholder: 'Code',
      type: FormInputTypes.newsplitprefix,
      value: model?.code ?? model?.ModelCode ?? '',
      required: true,
      prefixValue,
      customValidator: (values) => {
        const code = values.code;
        if (!/^\d+$/.test(code)) {
          return 'Only numbers allowed';
        }
        return null;
      },
    },
    title: {
      name: 'title',
      title: 'Title',
      type: FormInputTypes.text,
      value: model?.title ?? model?.Title ?? '',
      required: true,
      placeholder: 'Title',
    },
  };
};
